import { mpoPathnames } from "@flixbus-phx/marketplace-common";
import restoreImageSources from "../restoreImageSources/restoreImageSources";

export default (htmlString: string) => {
  if (!htmlString) {
    return [];
  }

  // Replace src with data-src before parsing to prevent browser from fetching images
  const htmlWithChangedImageSrcAttribute = htmlString.replace(/<img([^>]*)src="([^"]*)"/g, '<img$1data-src="$2"');

  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlWithChangedImageSrcAttribute, "text/html");

  doc.querySelectorAll("[data-faq-article]").forEach((el) => {
    el.setAttribute("href", `${mpoPathnames.faq}/${el.getAttribute("data-faq-article")}`);
    el.removeAttribute("data-faq-article");
  });

  const sections = doc.querySelectorAll("section");

  return Array.from(sections)
    .filter((section) => section.id)
    .map((section) => {
      const contentElement = section.querySelector("faq-content");
      return {
        id: section.id,
        headline: section.querySelector("faq-headline")?.textContent?.trim() || "",
        category: section.querySelector("faq-category")?.textContent?.trim() || "",
        content: contentElement?.textContent?.trim() || "",
        contentHtml: restoreImageSources(contentElement?.innerHTML?.trim() || ""),
      };
    });
};
